module.exports = __webpack_public_path__ + "static/media/icon-dashboard-preapprovals.6805c5a1.svg";